import { compareVersion as o } from "@liff/util";
import { getOS as i } from "@liff/get-os";
import { getLineVersion as f } from "@liff/get-line-version";
import { call as l } from "@liff/native-bridge";

function e() {
  var e = f();
  null !== e && ("ios" === i() && o(e, "9.19") >= 0 || "android" === i() && o(e, "11.6.0") >= 0) ? location.href = "liff://close" : window._liff && window._liff.postMessage ? null !== e && o(e, "10.15.0") >= 0 ? "ios" === i() ? window._liff.postMessage("closeWindow", "") : window._liff.postMessage("closeWindow", "", "", "") : l("closeWindow") : window.close();
}

export { e as closeWindow };